import { useState } from 'react'
import PropTypes from 'prop-types'
import { ArrowSquareUp, GearSix } from '@phosphor-icons/react'
import { Trans, useTranslation } from 'react-i18next'

import SuccessConfirmationModal from '../../../../Popups/SuccessConfirmationModal'
import { useSnackbar } from '../../../../../helpers/hooks/useSnackbar'
import API from '../../../../../api/api'

const AdvancedTicketingUpselling = ({
  onClose = () => {},
  buildingId,
  advancedTicketingEnabled,
}) => {
  const { t } = useTranslation(['eventManagement'])
  const { displaySnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)
  const [isConfirmationVisible, setIsConfirmationVisible] = useState(false)

  const sendUpsellingMessage = async () => {
    try {
      setIsLoading(true)
      await API.sendUpsellingMessage({ type: 'multipleEventTickets' }, buildingId)
      setIsConfirmationVisible(true)
    } catch ({ message }) {
      displaySnackbar(message, true)
    } finally {
      setIsLoading(false)
    }
  }

  if (isConfirmationVisible) {
    return (
      <SuccessConfirmationModal
        header={t('eventManagement:upselling.requestSentHeader')}
        description={t('eventManagement:upselling.requestSentDescription')}
        handleClose={() => {
          setIsConfirmationVisible(false)
          onClose()
        }}
      />
    )
  }

  return (
    <>
      <div className="advanced-ticketing-upselling-modal">
        <div className="advanced-ticketing-upselling-modal__overlay" onClick={onClose} />
        <div className="advanced-ticketing-upselling-modal__container">
          <div className="advanced-ticketing-upselling-modal__content">
            <div className="advanced-ticketing-upselling-modal__left">
              <div className="advanced-ticketing-upselling-modal__header">
                <ArrowSquareUp size={24} weight="fill" />
                <span>{t('eventManagement:upselling.headerBadge')}</span>
              </div>
              <h2 className="advanced-ticketing-upselling-modal__title">
                {t('eventManagement:upselling.modalTitle')}
              </h2>
              <p className="advanced-ticketing-upselling-modal__description">
                {t('eventManagement:upselling.modalDescription')}
              </p>
              <div className="advanced-ticketing-upselling-modal__benefits">
                <div className="advanced-ticketing-upselling-modal__benefits-header">
                  <img src="/images/star.svg" alt="" />
                  <span>{t('eventManagement:upselling.benefitsHeader')}</span>
                </div>
                <ul className="advanced-ticketing-upselling-modal__benefits-list">
                  <li>
                    <strong>{t('eventManagement:upselling.benefit1Title')}</strong>
                    <br />
                    <Trans
                      i18nKey="eventManagement:upselling.benefit1Body"
                      components={[<strong key="0" />]}
                    />
                  </li>
                  <li>
                    <strong>{t('eventManagement:upselling.benefit2Title')}</strong>
                    <br />
                    <Trans
                      i18nKey="eventManagement:upselling.benefit2Body"
                      components={[<strong key="0" />]}
                    />
                  </li>
                  <li>
                    <strong>{t('eventManagement:upselling.benefit3Title')}</strong>
                    <br />
                    <Trans
                      i18nKey="eventManagement:upselling.benefit3Body"
                      components={[<strong key="0" />]}
                    />
                  </li>
                  <li>
                    <strong>{t('eventManagement:upselling.benefit4Title')}</strong>
                    <br />
                    <Trans
                      i18nKey="eventManagement:upselling.benefit4Body"
                      components={[<strong key="0" />]}
                    />
                  </li>
                </ul>
              </div>
              {!advancedTicketingEnabled && (
                <button
                  className="advanced-ticketing-upselling-modal__button"
                  disabled={isLoading}
                  onClick={sendUpsellingMessage}
                  type="button"
                >
                  <GearSix size={24} />
                  {t('eventManagement:upselling.talkToAccountManager')}
                </button>
              )}
            </div>
            <div className="advanced-ticketing-upselling-modal__right">
              <img
                src="/images/upselling/multiple-tickets.png"
                alt={t('eventManagement:upselling.modalTitle')}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

AdvancedTicketingUpselling.propTypes = {
  onClose: PropTypes.func,
  buildingId: PropTypes.number,
  advancedTicketingEnabled: PropTypes.bool,
}

export default AdvancedTicketingUpselling
